import cn from 'classnames';
import { FC } from 'react';

import { CustomButton, Icon } from '../../../components';
import { useFavorites } from '../../../components/screens/Favorites/useFavorites';
import { ICatalogItem } from '../../../shared/types/card';

import styles from './FavoriteButton.module.sass';

const FavoriteButton: FC<{ item: ICatalogItem; text?: boolean }> = ({
  item,
  text = true,
}) => {
  const {
    actions: { onAddToFavorite },
    favorite: { isSmashed },
  } = useFavorites();
  return (
    <CustomButton
      variant="outlined"
      className={cn(styles.button, {
        [styles.text]: text,
      })}
      onClick={() => onAddToFavorite(item)}
    >
      <>
        <Icon
          variant={isSmashed ? 'heartOrangeOutlined' : 'heartGrayOutlined'}
        />
        {text && <>{isSmashed ? <p>В избранном</p> : <p>В избранное</p>}</>}
      </>
    </CustomButton>
  );
};

export default FavoriteButton;
